var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.78711 6C1.41378 2.58667 4.40511 0 7.99978 0C11.5944 0 14.5851 2.58667 15.2124 6C14.5858 9.41333 11.5944 12 7.99978 12C4.40511 12 1.41444 9.41333 0.787109 6H0.78711ZM7.99934 9.33342C9.84029 9.33342 11.3327 7.84104 11.3327 6.00009C11.3327 4.15914 9.8403 2.66676 7.99936 2.66675C6.15841 2.66674 4.66603 4.15912 4.66602 6.00006C4.66601 7.84101 6.15838 9.3334 7.99932 9.33342H7.99934ZM8 8C7.28547 8 6.62522 7.6188 6.26795 7C5.91068 6.3812 5.91068 5.6188 6.26795 5C6.62522 4.3812 7.28547 4 8 4C8.71453 4 9.37479 4.3812 9.73205 5C10.0893 5.6188 10.0893 6.3812 9.73205 7C9.37479 7.6188 8.71453 8 8 8Z",
    fill: "#405189"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.bc74bf61cafa83dfbb592a37e287f49a.svg";
export { ForwardRef as ReactComponent };